import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface DropRequestDatumProps {
  label: string;
  value: ReactNode;
}

/** A compact label/value pair shared by every product's Drop request card. */
const DropRequestDatum = ({ label, value }: DropRequestDatumProps) => (
  <Box>
    <Typography component="dt" variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography component="dd" variant="body2" m={0}>
      {value}
    </Typography>
  </Box>
);

export default DropRequestDatum;
